import { useEffect, useState } from 'react';
import { Plano } from '../services/mockData';
import { useAuth } from '../contexts/AuthContext';
import { getPlanosRecentesForNutritionist } from '../services/dataService';

export function usePlanos() {
  const { user } = useAuth();
  const [data, setData] = useState<Plano[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let isMounted = true;

    async function load() {
      if (!user) {
        if (isMounted) {
          setData([]);
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const planos = await getPlanosRecentesForNutritionist(user.uid);
        if (isMounted) {
          setData(planos);
        }
      } catch {
        if (isMounted) {
          setError('Não foi possível carregar os planos.');
          setData([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      isMounted = false;
    };
  }, [user, revision]);

  return { planos: data, loading, error, refresh: () => setRevision(value => value + 1) };
}

